module.exports = __webpack_public_path__ + "img/@espantos.ecc32f70.png";